var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-field"},[_c('label',{staticClass:"text-field-label"},[_vm._v(_vm._s(_vm.label))]),_c('v-textarea',{attrs:{"solo":"","rules":_vm.rules,"type":_vm.type,"flat":true,"disabled":_vm.disabled},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }